import CenterScreen, { makeDataTestId as centerScreenMakeDataTestId } from '../../molecules/CenterScreen';
import Header from '../../molecules/Header';
import ErrorFooter from './ErrorFooter';
import PageLayout from '../../molecules/PageLayout';

export const makeDataTestId = (dataTestId = 'error-page-no-config') => centerScreenMakeDataTestId(dataTestId);

interface ErrorFooterProps {
  dataTestId?: string;
}

const ErrorPageWhenNoConfig: React.FC<ErrorFooterProps> = ({ dataTestId }) => (
  <PageLayout header={<Header />} footer={<ErrorFooter />}>
    <CenterScreen
      title="Oh no, something went wrong"
      text="The page you’re looking for is momentarily unavailable. Please revisit the email or page that sent you here and try again."
      dataTestId={makeDataTestId(dataTestId).prefix}
    />
  </PageLayout>
);

export default ErrorPageWhenNoConfig;
